import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  Input,
  Button,
  ControlLabel,
  RadioGroup,
  Radio,
  Icon,
  IconButton,
  SelectPicker,
  Message,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { useHistory, useParams } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'
import CustomAlertMessageInfo from '../CustomAlertMessageInfo'
import { Link } from 'react-router-dom'
import {
  saveProposeConsiderApproveMultiProject,
  updateProposeConsiderApproveMultiProject,
} from '../../redux/actions/multiReview'

export default function ProposeConsiderApproveProjectMultiWidget({
  onComplete = () => {},
  ...props
}) {
  const { showCommandButton, disabled, onEnableForm, isConfirmEbudget } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [schema, setFormSchema] = useState(props.schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [contractSignType, setContractSignType] = useState(
    schema.contractSignType.value ? parseInt(schema.contractSignType.value) : 1
  )
  const [thaiHealthWitnessList, setThaiHealthWitnessList] = useState([])
  const [granteeWitnessList, setGranteeWitnessList] = useState([])
  const [isShowConfimPullBackModal, setIsShowConfimPullBackModal] = useState(false)
  const [submitRequest, setSubmitRequest] = useState()

  useEffect(() => {
    let arr = schema?.thaiHealthWitness?.values || []
    // console.log('schema.thaiHealthWitness', arr)

    if (
      schema?.thaiHealthWitness?.firstName?.value &&
      schema?.thaiHealthWitness?.lastName?.value &&
      schema?.thaiHealthWitness?.honorific?.value
    ) {
      let newList = [
        {
          honorific: schema?.thaiHealthWitness?.honorific?.value,
          firstName: schema?.thaiHealthWitness?.firstName?.value,
          lastName: schema?.thaiHealthWitness?.lastName?.value,
        },
      ]
      setThaiHealthWitnessList(newList)
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      setThaiHealthWitnessList(initialList)
    }
  }, [schema?.thaiHealthWitness])

  useEffect(() => {
    let arr = schema?.granteeWitness?.values || []
    if (
      schema?.granteeWitness?.firstName?.value &&
      schema?.granteeWitness?.lastName?.value &&
      schema?.granteeWitness?.honorific?.value
    ) {
      let newList = [
        {
          honorific: schema?.granteeWitness?.honorific?.value,
          firstName: schema?.granteeWitness?.firstName?.value,
          lastName: schema?.granteeWitness?.lastName?.value,
        },
      ]
      setGranteeWitnessList(newList)
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      setGranteeWitnessList(initialList)
    }
  }, [schema?.granteeWitness])

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveProposeConsiderApproveMultiProject(id, request)
      doneLoading()
      onComplete(response)
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnConfirmPullBackModal = () => {
    onEnableForm()
    setIsShowConfimPullBackModal(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let _thaiHealthWitness = thaiHealthWitnessList.map((item, index) => {
      item.honorific =
        data[schema.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index]
      item.firstName =
        data[schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index]
      item.lastName =
        data[schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index]
      return item
    })

    let _granteeWitness = granteeWitnessList.map((item, index) => {
      item.honorific = data[schema.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index]
      item.firstName = data[schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index]
      item.lastName = data[schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index]
      return item
    })

    // console.log('_thaiHealthWitness', _thaiHealthWitness)
    // console.log('_granteeWitness', _granteeWitness)

    let request = {
      // id: schema.inputNote.id,
      value: data.note,
      contractsignType: data.contractsignType,
      valueToReport: data.noteToReport,

      thaiHealthWitnessHonorific: _thaiHealthWitness[0].honorific || '',
      thaiHealthWitnessFirstName: _thaiHealthWitness[0].firstName || '',
      thaiHealthWitnessLastName: _thaiHealthWitness[0].lastName || '',
      granteeWitnessHonorific: _granteeWitness[0].honorific || '',
      granteeWitnessFirstName: _granteeWitness[0].firstName || '',
      granteeWitnessLastName: _granteeWitness[0].lastName || '',
    }

    // console.log('request', request)

    setSubmitRequest(request)
    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = () => {
    setIsShowConfimModal(false)
    handleCallService(projectId, submitRequest)
  }

  const handlePlusThaiHealthWitness = () => {
    let arr = [...thaiHealthWitnessList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setThaiHealthWitnessList(arr)
  }

  const handleDeleteThaiHealthWitness = (index) => {
    let arr = [...thaiHealthWitnessList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setThaiHealthWitnessList(arr)
  }

  const handlePlusGranteeWitness = () => {
    let arr = [...granteeWitnessList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setGranteeWitnessList(arr)
  }

  const handleDeleteGranteeWitness = (index) => {
    let arr = [...granteeWitnessList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setGranteeWitnessList(arr)
  }

  const renderThaiHealthWitness = thaiHealthWitnessList.map((item, index) => {
    return (
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 70 }}>
          {/* {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'} */}
          <span>พยาน {index + 1}</span>
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema?.thaiHealthWitness?.honorific?.validators) && 'required'
            )}
          >
            {schema?.thaiHealthWitness?.honorific?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema?.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Controller
            name={schema?.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(schema?.thaiHealthWitness?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={schema?.thaiHealthWitness?.honorific?.options || []}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  disabled={!showCommandButton || disabled}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.thaiHealthWitness?.firstName?.validators) && 'required'
            )}
          >
            {schema.thaiHealthWitness?.firstName?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Input
            placeholder={schema.thaiHealthWitness?.firstName?.label}
            defaultValue={item.firstName}
            name={schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index}
            inputRef={register(isValidators(schema.thaiHealthWitness?.firstName?.validators))}
            disabled={!showCommandButton || disabled}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.thaiHealthWitness?.lastName?.validators) && 'required'
            )}
          >
            {schema.thaiHealthWitness?.lastName?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Input
            placeholder={schema.thaiHealthWitness?.lastName?.label}
            defaultValue={item.lastName}
            name={schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index}
            inputRef={register(isValidators(schema.thaiHealthWitness?.lastName?.validators))}
            disabled={!showCommandButton || disabled}
          />
        </Col>
        {index >= 1 && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteThaiHealthWitness(index)}
              style={{ marginLeft: 5 }}
              disabled={!showCommandButton || disabled}
            ></IconButton>
          </Col>
        )}

        {thaiHealthWitnessList.length - 1 === index && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 32, width: 50 }}>
            {/* <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusThaiHealthWitness()}
            >
              เพิ่ม{schema.thaiHealthWitness?.buttonText}
            </IconButton> */}
          </Col>
        )}
      </Row>
    )
  })

  const renderGranteeWitness = granteeWitnessList.map((item, index) => {
    return (
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 70 }}>
          {/* {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'} */}
          <span>พยาน {index + 1}</span>
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema?.granteeWitness?.honorific?.validators) && 'required'
            )}
          >
            {schema?.granteeWitness?.honorific?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema?.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Controller
            name={schema?.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(schema?.granteeWitness?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={schema?.granteeWitness?.honorific?.options || []}
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  disabled={!showCommandButton || disabled}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.granteeWitness?.firstName?.validators) && 'required'
            )}
          >
            {schema.granteeWitness?.firstName?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Input
            placeholder={schema.granteeWitness?.firstName?.label}
            defaultValue={item.firstName}
            name={schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index}
            inputRef={register(isValidators(schema.granteeWitness?.firstName?.validators))}
            disabled={!showCommandButton || disabled}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.granteeWitness?.lastName?.validators) && 'required'
            )}
          >
            {schema.granteeWitness?.lastName?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Input
            placeholder={schema.granteeWitness?.lastName?.label}
            defaultValue={item.lastName}
            name={schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index}
            inputRef={register(isValidators(schema.granteeWitness?.lastName?.validators))}
            disabled={!showCommandButton || disabled}
          />
        </Col>
        {index >= 1 && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteGranteeWitness(index)}
              style={{ marginLeft: 5 }}
              disabled={!showCommandButton || disabled}
            ></IconButton>
          </Col>
        )}

        {granteeWitnessList.length - 1 === index && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 32, width: 50 }}>
            {/* <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusGranteeWitness()}
            >
              เพิ่ม{schema.granteeWitness?.buttonText}
            </IconButton> */}
          </Col>
        )}
      </Row>
    )
  })

  return (
    <>
      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        {schema.contractSignType && (
          <Row>
            {schema.contractSignType?.descriptions && (
              <CustomAlertMessageInfo contents={schema.contractSignType.descriptions} />
            )}
            <ErrorMessage error={errors[schema.contractSignType.name]} />
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ControlLabel className="required">{schema.contractSignType.label}</ControlLabel>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <Controller
                key={schema.contractSignType.name}
                name={schema.contractSignType.name}
                control={control}
                rules={isValidators(schema.contractSignType.validators)}
                defaultValue={
                  schema.contractSignType.value ? parseInt(schema.contractSignType.value) : 0
                }
                render={(props) => {
                  return (
                    <RadioGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        // console.log('contractSignType : ', value)
                        setContractSignType(value)
                      }}
                    >
                      {schema.contractSignType?.options?.map((item, index) => {
                        return (
                          <Radio
                            value={item.value}
                            key={index}
                            disabled={!showCommandButton || disabled}
                          >
                            {item.label}{' '}
                          </Radio>
                        )
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
          </Row>
        )}
        <br />
        {contractSignType == 2 && (
          <>
            <div>
              {schema.thaiHealthWitness && (
                <>
                  <span>{schema.thaiHealthWitness.header}</span>
                  <Row>
                    {renderThaiHealthWitness}

                    {thaiHealthWitnessList.length === 0 && (
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                          }
                          onClick={() => handlePlusThaiHealthWitness()}
                          disabled={!showCommandButton || disabled}
                        >
                          เพิ่ม{schema.thaiHealthWitness.buttonText}
                        </IconButton>
                      </Col>
                    )}
                  </Row>
                  <br />
                </>
              )}
            </div>

            <br />

            <div>
              {schema.granteeWitness && (
                <>
                  <span>{schema.granteeWitness.header}</span>
                  <Row>
                    {renderGranteeWitness}

                    {granteeWitnessList.length === 0 && (
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                          }
                          onClick={() => handlePlusGranteeWitness()}
                          disabled={!showCommandButton || disabled}
                        >
                          เพิ่ม{schema.granteeWitness.buttonText}
                        </IconButton>
                      </Col>
                    )}
                  </Row>
                  <br />
                </>
              )}
            </div>
          </>
        )}

        <InputForm
          schema={schema.inputNoteToReport}
          placeholder={schema.inputNoteToReport.plachoderText}
          rows={7}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          disabled={!showCommandButton || disabled}
        />
        <br />
        <InputForm
          schema={schema.inputNote}
          placeholder={schema.inputNote.plachoderText}
          rows={7}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          disabled={!showCommandButton || disabled}
        />

        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="error"
              description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
            />
          </Row>
        )}

        {showCommandButton ? (
          <>
            <hr />
            {!isConfirmEbudget && (
              <Message
                showIcon
                type="error"
                description={
                  <div>
                    <span>
                      กรุณายืนยันงบประมาณทุกโครงการก่อนส่งเสนอพิจารณาอนุมัติทุนโครงการ &nbsp;
                    </span>
                    <Link
                      to={{
                        pathname: `${pathname.proposal.review.paymentCheckMulti}`,
                      }}
                      onClick={() => {
                        sessionStorage.setItem('projectId', projectId)
                        sessionStorage.setItem('param', '')
                      }}
                    >
                      <u>ไปหน้า ตรวจสอบงวดเงิน</u>
                    </Link>
                    <span>&nbsp;เพื่อยืนยันงบประมาณ</span>
                  </div>
                }
                style={{ marginBottom: 10 }}
              />
            )}
            <Button
              // style={{ width: 160 }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={isLoading || disabled || !showCommandButton || !isConfirmEbudget}
            >
              {schema.buttonText}
            </Button>
          </>
        ) : (
          <>
            <hr />
            <Button
              // style={{ width: 160 }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={() => setIsShowConfimPullBackModal(true)}
              //disabled={disabled || !showCommandButton}
              disabled={isLoading}
            >
              {'ดึงรายงานเสนออนุมัติโครงการกลับเพื่อขอเสนออนุมัติใหม่ '}
            </Button>
          </>
        )}

        <ConfirmWidget
          // title={`ยืนยันการ${schema.buttonText}`}
          show={isShowConfimModal}
          detail={`กรุณายืนยันการ${schema.buttonText}`}
          onCancle={() => setIsShowConfimModal(false)}
          onConfirm={handleOnConfirmModal}
        />

        <ConfirmWidget
          title={`ยืนยันการดึงรายงานเสนออนุมัติโครงการกลับเพื่อขอเสนออนุมัติใหม่`}
          show={isShowConfimPullBackModal}
          size={'md'}
          detail={`กรุณายืนยันการดึงรายงานเสนออนุมัติโครงการกลับเพื่อขอเสนออนุมัติใหม่`}
          onCancle={() => setIsShowConfimPullBackModal(false)}
          onConfirm={handleOnConfirmPullBackModal}
        />
      </Panel>
    </>
  )
}
